// Chat Challenge conversation flows for all 8 conversation types

export const getChatChallengeFlow = (conversationNum, topicText) => {
    const flows = {
        // 0: Favorite Things - Animal
        0: [
            {
                text: "Say, \"We are going to talk about our favorite animal.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Greet your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me.\"",
            },
            {
                text: "Ask, \"What is your favorite animal?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask you a question about your favorite animal?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
            },
            {
                text: "Answer your friend's question.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
            },
            {
                text: "Close the conversation with your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 1: Talk about Feelings
        1: [
            {
                text: "Say, \"We are going to talk about what makes you feel confident.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Ask, \"What makes you feel confident?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question? (I feel confident when_____.)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: "Say, \"I'm glad that makes you feel confident when ______.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend thank you?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to thank me.\"",
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 2: Active Listening
        2: [
            {
                text: "Say, \"We are going to talk about what makes me feel calm.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Ask me what makes me feel calm.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask, \"What makes you feel calm?\"",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
            },
            {
                text: "Say, “I feel calm when ______.”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, “I’m glad you feel calm when ______.”",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to say, \"I’m glad you feel calm when ______.\"\"",
            },
            {
                text: "Say, “Thank you.”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 3: Making Friends
        3: [
            {
                text: "Say, \"We are going to talk about our favorite thing to do outside.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Greet me and ask me my name.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you and ask your name?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask me a question.\"",
            },
            {
                text: "Greet your friend and say your name.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask you, \"What is your favorite thing to do outside?\"",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question about my favorite thing to do outside.\"",
            },
            {
                text: "Answer your friend's question.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
            },
            {
                text: "Ask, \"What is your favorite thing to do outside?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },
            {
                text: "Close the conversation with your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, “Good job making friends. Now let’s practice how to stop bullying.”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, “If someone is bullying you, what are the three steps to stop bullying?”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did they say, “Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.”",
                type: "question",
                sender: "friend",
                reminder: "Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.",
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            },
        ],

        // 4: Solutions
        4: [
            {
                text: "Say, \"We are going to talk about what makes you feel nervous.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Ask, \"What makes you feel nervous?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question? (I feel nervous when ______.)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: "Say, “I’m sorry you feel nervous when ______. Ask, “What is a solution?”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 5: Resolve Conflict
        5: [
            {
                text: "Say, “If I sat where you wanted to sit on the bus and it made you feel sad, how would you resolve the conflict? Tell me the first step.”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Be Calm\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Be Calm.'\"",
            },
            {
                text: "Say, \"What is the second step to resolve conflict?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Talk About It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Talk About It.'\"",
            },
            {
                text: "Say, “If I was sitting where you wanted to sit, how would you tell me how you feel?”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I feel sad because _____.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, “Remember to say, ‘I feel sad because ______.’”",
            },
            {
                text: "Say, \"What is the third step to resolve conflict?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Make It Better\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
            },
            {
                text: "Say, \"How can you make this situation better?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend tell you how they can make it better?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to tell me how to make the situation better.\"",
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 6: Self-Advocacy
        6: [
            {
                text: "Say, \"If you are at the snack shack and need a napkin, what is the first step to self-advocate?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Think About What You Want to Say\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Think About What You Want to Say.'\"",
            },
            {
                text: "Say, \"What is the second step to self-advocate?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Believe in Yourself\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Believe in Yourself.'\"",
            },
            {
                text: "Say, \"Can you sing or say the Joyful Jingle?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend sing or say the Joyful Jingle?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Let's sing or say the Joyful Jingle together!\"",
            },
            {
                text: "Say, \"What is the third step to self-advocate?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Achieve It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Achieve It.'\"",
            },
            {
                text: "Say, “Now, let’s practice the conversation.”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Hi! I work at the snack shack. How can I help you?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you and ask where the napkins are?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask where the napkins are.\"",
            },
            {
                text: "Say, \"Sure! The napkins are right by the drinks.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer with good manners?",
                type: "question",
                sender: "friend",
                reminder: "Say, “Remember to respond to my answer with good manners.”",
            },
            {
                text: "Close the conversation.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 7: Community Locations
        7: [
            {
                text: "Say, \"If you are at the clothing store to buy new socks for yourself and you don't know where they are, what is the first step to care for yourself?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"See It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'See It.'\"",
            },
            {
                text: "Say, \"What problem do you see?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I don't know where the socks are in the store.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember that you don't know where the socks are in the store.\"",
            },
            {
                text: "Say, \"What is the second step to care for yourself?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Fix It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Fix It.'\"",
            },
            {
                text: "Say, \"How would you fix this problem?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I will ask a worker for help.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask a worker for help.\"",
            },
            {
                text: "Say, \"What is the third step to care for yourself?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Make It Better\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
            },
            {
                text: "Say, \"What can you say or do for the worker who helped you find the socks?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say something nice?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to say or do something nice for the worker.\"",
            },
            {
                text: "Say, \"Now, let's practice having a conversation using good manners.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Hi! I work at a clothing store. How can I help you?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet the worker and ask where the socks are while using good manners? (Please)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet the worker and use good manners when asking where the socks are.\"",
            },
            {
                text: "Say, \"The socks are on the first aisle on your left.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond using good manners? (Thank you)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond using good manners.\"",
            },
            {
                text: "Say, “You’re welcome. Have a good day!”",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },            
            {
                title: "Step 1: How I Act",
                text: "Did your friend use the 5 foundational skills (eye contact, listening, smile, posture, distance)?",
                type: "question",
                sender: "friend",
            },
            {
                title: "Step 2: What I Say",
                text: "Did your friend use kind words?",
                type: "question",
                sender: "friend",
            },
            {
                title: "Step 3: How I say it",
                text: "Did your friend talk in a calm voice?",
                type: "question",
                sender: "friend",
            },
            {
                text: "Say, “Good job! You completed the Chat Challenge!”",
                type: "instruction",
                sender: "friend"
            }
        ]
    };

    return flows[conversationNum] || flows[0];
};

